export default __webpack_public_path__ + "static/media/TreasureHunting_08.46ee8269.png";